import { DefaultFormConfig, setFormConfig } from 'sos-eservice-common/js/config';
import { ResourceItem } from 'sos-common/js/commonTypes/resourceItem';
import { StepFieldsMap } from 'sos-common/js/commonTypes/validation.types';
export class OmbudConfig extends DefaultFormConfig {
  constructor(translations: ResourceItem[], public basePath: string, public stepFieldsMap: StepFieldsMap) {
    super(translations, basePath, stepFieldsMap);
  }
}
